import createEmailRegExp from 'email-regex';

export { createEmailRegExp };
